import {
  AudienceExplorerStores,
  AudienceExplorerChannel,
} from "@/lib/websocket/channels/AudienceExplorer";
import {
  CableRankerStores,
  CableRankerChannel,
} from "@/lib/websocket/channels/CableRanker";
import {
  CampaignEffectivenessStores,
  CampaignEffectivenessChannel,
} from "@/lib/websocket/channels/CampaignEffectiveness";
import {
  NotificationStores,
  NotificationChannel,
} from "@/lib/websocket/channels/Notifications";
import {
  PaidEarnedMediaStores,
  PaidEarnedMediaChannel,
} from "@/lib/websocket/channels/PaidEarnedMedia";
import {
  RateCardStores,
  RateCardChannel,
} from "@/lib/websocket/channels/RateCard";
import {
  ReachAndFrequencyStores,
  ReachAndFrequencyChannel,
} from "@/lib/websocket/channels/ReachAndFrequency";
import {
  AdExplorerStores,
  AdExplorerChannel,
} from "@/lib/websocket/channels/AdExplorer";
import {
  SlackUserActivityStores,
  SlackUserActivityChannel,
} from "@/lib/websocket/channels/SlackUserActivity";
import {
  TvRatingsStores,
  TvRatingsChannel,
} from "@/lib/websocket/channels/TvRatings";
import {
  TvViewershipStores,
  TvViewershipChannel,
} from "@/lib/websocket/channels/TvViewership";
import {
  AudienceBuilderStores,
  AudienceBuilderChannel,
} from "@/lib/websocket/channels/AudienceBuilder";
import {
  MetaAudienceStores,
  MetaAudienceChannel,
} from "@/lib/websocket/channels/MetaAudience";
import {
  ResearchStudioStores,
  ResearchStudioChannel,
} from "@/lib/websocket/channels/ResearchStudio";
import {
  ResearchStores,
  ResearchChannel,
} from "@/lib/websocket/channels/Research";
export const WebSocketStores = [
  ...new Set([
    ...AudienceExplorerStores,
    ...CableRankerStores,
    ...CampaignEffectivenessStores,
    ...NotificationStores,
    ...PaidEarnedMediaStores,
    ...RateCardStores,
    ...ReachAndFrequencyStores,
    ...TvRatingsStores,
    ...TvViewershipStores,
    ...SlackUserActivityStores,
    ...AudienceBuilderStores,
    ...MetaAudienceStores,
    ...ResearchStudioStores,
    ...AdExplorerStores,
    ...ResearchStores,
  ]),
];

export const WebSocketChannels = {
  AudienceExplorer: AudienceExplorerChannel,
  CableRanker: CableRankerChannel,
  CampaignEffectiveness: CampaignEffectivenessChannel,
  NotificationChannel: NotificationChannel,
  PaidEarnedMedia: PaidEarnedMediaChannel,
  RateCard: RateCardChannel,
  ReachAndFrequency: ReachAndFrequencyChannel,
  AdExplorer: AdExplorerChannel,
  SlackUserActivity: SlackUserActivityChannel,
  TvRatings: TvRatingsChannel,
  TvViewership: TvViewershipChannel,
  AudienceBuilder: AudienceBuilderChannel,
  MetaAudience: MetaAudienceChannel,
  ResearchStudio: ResearchStudioChannel,
  Research: ResearchChannel,
};
